/* eslint-disable no-unused-vars */
import MuiInput from '@mui/material/Input';
import MuiSlider from '@mui/material/Slider';
import React from 'react';
import shortUUID from 'short-uuid';
import './styles.css';

export const Slider = ({
  id,
  label,
  className,
  minValue,
  maxValue,
  // value,
  // onChange,
  field,
  form,
  // tooltip,
  // ...props
}) => {
  const uuid = shortUUID.generate();
  const [value, setValue] = React.useState(field.value ? field.value : 0);

  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
    if (field) {
      form.setFieldValue(field.name, newValue);
    }
  };

  const handleInputChange = (event) => {
    setValue(
      event.target.value === ''
        ? 0
        : Number(parseFloat(event.target.value).toFixed(2))
    );
    if (field) {
      form.setFieldValue(
        field.name,
        event.target.value === ''
          ? 0
          : Number(parseFloat(event.target.value).toFixed(2))
      );
    }
  };

  const handleBlur = () => {
    if (value < minValue) {
      setValue(minValue);
      if (field) {
        form.setFieldValue(field.name, minValue);
      }
    } else if (value > maxValue) {
      setValue(maxValue);
      if (field) {
        form.setFieldValue(field.name, maxValue);
      }
    }
  };

  return (
    <div className="slider-container">
      <label className={`slider-label ${className}`} htmlFor={id || uuid}>
        {label || ''}
      </label>
      <div className="slider-wrapper">
        <div className="slider-content">
          <p className="min-max-values">{minValue}%</p>
          <MuiSlider
            className="slider-bar"
            value={typeof value === 'number' ? value : 0}
            onChange={handleSliderChange}
            onBlur={handleBlur}
            min={minValue}
            max={maxValue}
            valueLabelDisplay="auto"
            valueLabelFormat="Arraste até o percentual desejado"
          />
          <p className="min-max-values">{maxValue}%</p>
        </div>

        <MuiInput
          value={value}
          size="small"
          onChange={handleInputChange}
          onBlur={handleBlur}
          className="slider-input"
          inputProps={{
            step: 10,
            min: minValue,
            max: maxValue,
            type: 'number',
          }}
        />
      </div>
    </div>
  );
};
